import { useTranslation } from 'react-i18next';
import { href, Link, useParams } from 'react-router';

import { Button, Menu, Text } from '@valwin/facto/components';
import { CircleUserIcon } from '@valwin/facto/icons';

import { useProfile } from '~entities/user';
import { useLogout } from '~features/auth';
import { ROUTES } from '~shared/routes';

export function Profile() {
  const { t } = useTranslation();

  const { group = '' } = useParams();
  const { profile } = useProfile();
  const { onLogout } = useLogout();

  const onLogoutClick = () => {
    onLogout(group);
  };

  return (
    <Menu loopFocus positioning={{ placement: 'bottom-end' }}>
      <Menu.Trigger asChild>
        <Button size="sm" variant="ghost" colorPalette="gray">
          <Text
            as="span"
            color="brand.solid"
            fontWeight="bold"
            letterSpacing="wider"
          >
            {(profile?.shortName as string | undefined) ?? ''}
          </Text>

          <CircleUserIcon size="md" color="brand.solid" />
        </Button>
      </Menu.Trigger>

      <Menu.Content>
        <Menu.Item key="Profil" value={t('navigation profile')}>
          <Link
            to={href(ROUTES.profile, { group })}
            style={{
              color: 'inherit',
              outline: 'none',
              width: '100%',
              height: '100%',
              textDecoration: 'none',
            }}
          >
            {t('navigation profile')}
          </Link>
        </Menu.Item>
        <Menu.DangerItem
          key="Déconnexion"
          value={t('auth logout')}
          onClick={onLogoutClick}
        >
          {t('auth logout')}
        </Menu.DangerItem>
      </Menu.Content>
    </Menu>
  );
}
